import React from 'react'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'

interface PreviewModalProps {
  visible: boolean
  onHide: () => void
  previewImage: string | null
  previewImageUrl: string | null
  previewFileName: string
}

const PreviewModal: React.FC<PreviewModalProps> = ({
  visible,
  onHide,
  previewImage,
  previewImageUrl,
  previewFileName,
}) => {
  return (
    <Dialog
      header={`Preview: ${previewFileName}`}
      visible={visible}
      style={{ width: '90vw', maxWidth: '900px' }}
      onHide={onHide}
      className="preview-modal-dialog"
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            label="Close"
            className="p-button-text"
            onClick={onHide}
          />
        </div>
      }
    >
      {(previewImage || previewImageUrl) && (
        <div className="preview-modal__content">
          <img
            src={(previewImage || previewImageUrl) || ''}
            alt={previewFileName}
            className="preview-modal__image"
          />
          <div className="preview-modal__filename">
            {previewFileName}
          </div>
        </div>
      )}
    </Dialog>
  )
}

export default PreviewModal 